import React, {useState} from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Modal from 'react-bootstrap/Modal';

import {Route, Switch, useHistory, useRouteMatch} from "react-router-dom";

import Trainer, {createSkeletonTrainer, labeler} from './trainer/Trainer.js';
import {filter as trainerFilter} from './trainer/TrainerUtils.js';
import List from './util/List.js';
import Confirmation from './util/Confirmation.js'
import RoutingClients from './client/RoutingClients.js';
import RoutingKairogramm from './client/RoutingKairogramm.js';

import {trainerOrderFuncs} from './util/Util.js';
import Stats from "./Stats";


/* root element for admins */

const AdminRoot = ({
	showInfo,
	products,
	productData,
	trainers,
	createTrainer,
	setTrainerEnabled,
	updateTrainer,
	setTrainerPassword,
	createClient,
	removeClient,
	updateClient,
	issueQuestionnaire,
	checkForQuestionnaire,
	deleteNewestQuestionnaire,
	createAnalysis,
}) => {
	// routing
	let { url } = useRouteMatch();
	const rootUrl = url;

	// remove ending / so we don't get //
	if (url.endsWith('/'))
		url = url.substring(0, url.length - 1);

	const history = useHistory();


	// action
	const [action, setAction] = useState();

	// on the trainer list: select, start creating
	const selectTrainer = id => {
		console.log(`selected a trainer`);
		history.push(`${url}/${id}`);
		setAction();
	};

	const startCreating = () => {
		console.log(`started creating a trainer`);
		history.push(rootUrl);
		setAction('create');
	};


	// on a trainer: start editing, remove;

	const startEditing = () => {
		console.log(`started editing a trainer`);
		setAction('edit');
	};

	const [removalConfirmation, setRemovalConfirmation] = useState();

	const handleCreateTrainer = async (...args) => {
		const createdTrainer = await createTrainer(...args);
		setAction();
		history.push(`${url}/${createdTrainer.id}`);
	}

	const handleUpdateTrainer = async (...args) => {
		await updateTrainer(...args);
		setAction();
	};

	const actuallySetTrainerEnabled = async (...args) => {
		await setTrainerEnabled(...args);
		setRemovalConfirmation();
	}

	const handleSetTrainerEnabled = (id, enabled) => {
		setRemovalConfirmation((
			<Confirmation
				title = {`Trainer wirklich ${enabled ? 'aktivieren' : 'deaktivieren'}?`}
				actionLabel = {enabled ? 'aktivieren' : 'deaktivieren'}
				onAction = {() => actuallySetTrainerEnabled(id, enabled)}
				cancelLabel = {'Abbrechen'}
				onCancel = {() => setRemovalConfirmation()}>
			</Confirmation>
		));
	};

	// cancel editing: return to trainer
	const cancelEditing = id => setAction();

	// cancel creating: return to overview
	const cancelCreating = () => {
		setAction();
		history.push(rootUrl);
	};


	// render

	return (
		<div className = {'admin-root'}>
			{removalConfirmation &&
			removalConfirmation
			}
			{/* content */}
			<Row>
				<Col>
					<Switch>
						<Route path = {'/statistics'}>
							<Stats
								trainers = {trainers}
								licenses = {productData.allLicenses}/>
						</Route>
						<Route path = {'/'}>
							<Route path = {`${url}/:id`}
								children = {({ match }) => {
								let trainer;
								if (action === 'create')
									trainer = createSkeletonTrainer(productData.allLicenses);
								else
									if (trainers && match)
										trainer = trainers.find(t => t.id === match.params.id);

								const RenderTrainer = ({
									item,
									...props
								}) => (
									<ListGroup.Item
										variant = {item.enabled ? null : 'secondary'}
										{...props}/>
								);

								return (
									<>
										<Row className = 'my-3'>
											<Col className={'col-4'}>
												<List className = {'trainer-list'}
													title = {'Trainer'}
													addButtonTitle = {'Neuer Trainer'}
													onAdd = {startCreating}
													onSelect = {selectTrainer}
													selected = {trainer}
													items = {trainers}
													RenderItem = {RenderTrainer}
													labeler = {labeler}
													filter = {trainerFilter}
													orderFuncs = {trainerOrderFuncs}/>
											</Col>
											<Col>
												{trainer &&
												<Trainer
													trainer = {trainer}
													action = {action}
													startEditing = {startEditing}
													cancelCreating = {cancelCreating}
													cancelEditing = {cancelEditing}
													create = {handleCreateTrainer}
													update = {trainerUpdate => handleUpdateTrainer(trainer.id, trainerUpdate)}
													remove = {handleSetTrainerEnabled}
													isAdmin = {true}
													licenseData = {productData.allLicenses}
													setTrainerPassword = {password =>
														setTrainerPassword(trainer.id, password)}/>
												}
											</Col>
										</Row>

										{trainer && action !== 'create' &&
										<>
											<RoutingClients className = 'my-3'
												clients = {trainer.clients}
												products = {products}
												productData = {productData}
												createAnalysis = {(clientId, date, analysis) =>
														createAnalysis(trainer.id, clientId, date, analysis)}
												issueQuestionnaire = {(client, questionnaireType) =>
													issueQuestionnaire(trainer.id, client, questionnaireType)}
												checkForQuestionnaire = {(client, questionnaireType) =>
													checkForQuestionnaire(trainer.id, client, questionnaireType)}
												deleteNewestQuestionnaire = {(client, questionnaireType) =>
													deleteNewestQuestionnaire(trainer.id, client, questionnaireType)}
												create = {newClient => createClient(trainer.id, newClient)}
												update = {(clientId, clientUpdate) =>
														updateClient(trainer.id, clientId, clientUpdate)}
												remove = {removedClient => removeClient(trainer.id, removedClient)}
												showInfo = {showInfo}/>

											<Route path = {'/:trainerId/clients/:clientId/kairogramm/:kairogrammId'}
												render = {routeProps => {
													const clientId = routeProps.match.params.clientId;
													const client = trainer.clients.find(c => c.id === clientId);

													return (
														<Modal
															dialogClassName = {'analysis-view'}
															show = {true}
															size = {'lg'}
															onHide = {() => {
																history.push(`/${trainer.id}/clients/${clientId}`);
															}}>
															<RoutingKairogramm
																client = {client}/>
														</Modal>
													);
												}}/>
										</>}
									</>
								);
							}}/>
						</Route>
					</Switch>
				</Col>
			</Row>
		</div>
	);
};

export default AdminRoot;

export const adminRoutes = [
	{
		path: '/statistics',
		crumble: () => [
			{
				text: 'Startseite',
				href: '/',
			},
			{
				text: 'Statistik',
				href: '/',
			}
		],
	},
	{
		path: '/:trainerId',
		crumble: (data, params) => {
			const tId = params.trainerId;
			const trainer = data.find(t => t.id === tId);
			if (!trainer)
				return [];
			return [
				{
					text: 'Startseite',
					href: '/',
				},
				{
					text: `${trainer.surname}, ${trainer.name}`,
					href: `/${tId}`,
				}
			];
		},
	},
	{
		path: '/:trainerId/clients/:clientId',
		crumble: (data, params) => {
			const tId = params.trainerId;
			const cId = params.clientId;
			const trainer = data.find(t => t.id === tId);
			if (!trainer)
				return [];
			const client = trainer.clients.find(c => c.id === cId);
			if (!client)
				return [];
			return [
				{
					text: 'Startseite',
					href: '/',
				},
				{
					text: `${trainer.surname}, ${trainer.name}`,
					href: `/${tId}`,
				},
				{
					text: `${client.surname}, ${client.name} ${client.team ? `[${client.team.name}]` : ''}`,
					href: `/${cId}`,
				},
			];
		},
	},
	{
		path: '/:trainerId/clients/:clientId/kairogramm/:kairogrammId',
		crumble: (data, params) => {
			const tId = params.trainerId;
			const cId = params.clientId;
			const kId = params.kairogrammId;
			const trainer = data.find(t => t.id === tId);
			if (!trainer)
				return [];
			const client = trainer.clients.find(c => c.id === cId);
			if (!client)
				return [];
			const kairogramm = client.kairogramme.find(k => k.id === kId);
			if (!kairogramm)
				return [];
			return [
				{
					text: 'Startseite',
					href: '/',
				},
				{
					text: `${trainer.surname}, ${trainer.name}`,
					href: `/${tId}`,
				},
				{
					text: `${client.surname}, ${client.name} ${client.team ? `[${client.team.name}]` : ''}`,
					href: `/${cId}`,
				},
				{
					text: `kairogramm`,
					href: `/${kId}`,
				}
			];
		}
	}
];
